import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c16e8e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jobs" }
const _hoisted_2 = { class: "job" }
const _hoisted_3 = { class: "job-name text-truncate" }
const _hoisted_4 = { class: "jobs-bottom" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "jobs-limit"
}
const _hoisted_8 = { class: "jobs-count" }

import {computed, ref} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import CustomJobsEditor from "@/components/customJobs/CustomJobsEditor.vue";
import DeleteCustomJob from "@/components/customJobs/DeleteCustomJob.vue";
import {CustomJob} from "@/types/CustomJob";
import {Guild} from "@/types/Guild";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomJobs',
  setup(__props) {

const route = useRoute()
const store = useStore()
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let jobs = ref(guild.value.settings?.customJobs ?? [])
let name = ref();

const limit = {
  standard: 5,
  boost: 15
}
let lim = guild.value?.settings?.boost ? limit.boost : limit.standard

function created(job: CustomJob) {
  jobs.value.push(job)
}

function deleted(job: CustomJob) {
  jobs.value.splice(jobs.value.findIndex(i => i.name === job.name), 1)
}

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(jobs).length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(jobs), (job) => {
            return (_openBlock(), _createElementBlock("div", {
              key: job.name
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(job.name), 1),
                _createElementVNode("div", null, [
                  _createVNode(CustomJobsEditor, {
                    job: job,
                    names: _unref(jobs).map(i => i.name),
                    class: "job-action"
                  }, null, 8, ["job", "names"]),
                  _createVNode(DeleteCustomJob, {
                    job: job,
                    class: "job-action",
                    onDelete: deleted
                  }, null, 8, ["job"])
                ])
              ]),
              _createVNode(_component_v_divider)
            ]))
          }), 128))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          (_unref(jobs).length < _unref(lim))
            ? (_openBlock(), _createBlock(CustomJobsEditor, {
                key: 0,
                names: _unref(jobs).map(i => i.name),
                onCreate: created
              }, null, 8, ["names"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_unref(guild).settings.boost)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('CustomJobs.subtitles.limit')), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_router_link, {
                        class: "donate-link",
                        to: "/donate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("favorite")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('CustomJobs.subtitles.donate')), 1)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('CustomJobs.subtitles.increaseLimit')) + " " + _toDisplayString(limit.boost), 1)
                    ]))
              ]))
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(jobs).length) + "/" + _toDisplayString(_unref(lim)), 1)
      ])
    ])
  ]))
}
}

})